<nav class="fixed top-0 left-0 right-0 z-50 w-full px-4 py-6 transition-all duration-300" style="background: transparent;">
    <div class="max-w-7xl mx-auto">
        <div class="flex items-center justify-center px-8 py-4 bg-[#1F1C1A] rounded-[40px] border-2 border-white">
            <!-- Logo -->
            <div class="flex-shrink-0">
                <div class="flex items-center gap-6">
                    <img src="assets/img/logo.jpg" alt="Codeingress Logo" class="h-[44px] w-auto" />
                    <span class="text-white font-bold text-3xl hidden md:block">Codeingress</span>
                </div>
            </div>

            <!-- Desktop Navigation -->
            <div class="hidden lg:flex flex-1 justify-end items-center gap-8">
                <!-- Nav Links -->
                <div class="flex items-center gap-8">
                    <a routerLink="/" routerLinkActive="text-yellow-400" [routerLinkActiveOptions]="{exact: true}"
                        class="text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal"
                        (click)="scrollToSection('home', $event)">
                        Home
                    </a>
                    <a routerLink="/services" routerLinkActive="text-yellow-400"
                        class="text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal"
                        >
                        Services
                    </a>
                    <a routerLink="/clients" routerLinkActive="text-yellow-400"
                        class="text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal"
                        (click)="scrollToSection('clients', $event)">
                        Clients
                    </a>
                    <a routerLink="/about" routerLinkActive="text-yellow-400"
                        class="text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal"
                        (click)="scrollToSection('about', $event)">
                        About Us
                    </a>

                    <!-- Testimonials Dropdown -->
                    <div class="relative" (mouseenter)="showDropdown()" (mouseleave)="hideDropdown()">
                        <button
                            class="flex items-center gap-1 text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal"
                            (click)="toggleDropdown()">
                            Testimonials
                            <svg class="w-6 h-6 transition-transform duration-200" [class.rotate-180]="isDropdownOpen()"
                                width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M12.3977 15.6629C12.178 15.8826 11.8219 15.8826 11.6022 15.6629L5.86739 9.92804C5.64772 9.70837 5.64772 9.35227 5.86739 9.13259L6.13256 8.86739C6.35222 8.64772 6.70838 8.64772 6.92805 8.86739L12 13.9393L17.0719 8.86739C17.2916 8.64772 17.6477 8.64772 17.8674 8.86739L18.1326 9.13259C18.3522 9.35227 18.3522 9.70837 18.1326 9.92804L12.3977 15.6629Z"
                                    fill="currentColor" />
                            </svg>
                        </button>

                        <!-- Dropdown Menu -->
                        <div class="absolute top-full right-0 mt-2 w-48 bg-[#1F1C1A] border-2 border-white rounded-2xl shadow-lg transform transition-all duration-200 origin-top"
                            [class.scale-100]="isDropdownOpen()" [class.scale-95]="!isDropdownOpen()"
                            [class.opacity-100]="isDropdownOpen()" [class.opacity-0]="!isDropdownOpen()"
                            [class.pointer-events-none]="!isDropdownOpen()">
                            <a routerLink="/testimonials"
                                class="block px-4 py-2 text-white hover:text-yellow-400 hover:bg-gray-800 transition-colors duration-200 first:rounded-t-2xl"
                                (click)="closeDropdown(); scrollToSection('testimonials', $event)">
                                Client Reviews
                            </a>
                            <a routerLink="/case-studies"
                                class="block px-4 py-2 text-white hover:text-yellow-400 hover:bg-gray-800 transition-colors duration-200 last:rounded-b-2xl"
                                (click)="closeDropdown()">
                                Case Studies
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Menu Button -->
                <button
                    class="flex items-center justify-center gap-2 px-5 py-2 text-white border-2 border-white rounded-full hover:bg-white hover:text-[#1F1C1A] transition-all duration-200 text-base font-medium"
                    (click)="openContactModal()">
                    Menu
                </button>
            </div>

            <!-- Mobile Menu Button -->
            <div class="lg:hidden flex-1 flex justify-end">
                <button
                    class="flex items-center justify-center gap-2 px-5 py-2 text-white border-2 border-white rounded-full hover:bg-white hover:text-[#1F1C1A] transition-all duration-200"
                    (click)="toggleMobileMenu()">
                    <span class="sr-only">Toggle menu</span>
                    <svg class="w-6 h-6 transition-transform duration-200" [class.rotate-90]="isMobileMenuOpen()"
                        fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 6h16M4 12h16M4 18h16"></path>
                    </svg>
                </button>
            </div>
        </div>

        <!-- Mobile Menu -->
        <div class="lg:hidden overflow-hidden transition-all duration-300 ease-in-out"
            [class.max-h-96]="isMobileMenuOpen()" [class.max-h-0]="!isMobileMenuOpen()">
            <div class="mt-4 p-6 bg-[#1F1C1A] rounded-[40px] border-2 border-white">
                <div class="flex flex-col gap-4">
                    <a routerLink="/" routerLinkActive="text-yellow-400" [routerLinkActiveOptions]="{exact: true}"
                        class="text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal py-2"
                        (click)="closeMobileMenu(); scrollToSection('home', $event)">
                        Home
                    </a>
                    <a routerLink="/services" routerLinkActive="text-yellow-400"
                        class="text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal py-2"
                        (click)="closeMobileMenu(); scrollToSection('services', $event)">
                        Services
                    </a>
                    <a routerLink="/clients" routerLinkActive="text-yellow-400"
                        class="text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal py-2"
                        (click)="closeMobileMenu(); scrollToSection('clients', $event)">
                        Clients
                    </a>
                    <a routerLink="/about" routerLinkActive="text-yellow-400"
                        class="text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal py-2"
                        (click)="closeMobileMenu(); scrollToSection('about', $event)">
                        About Us
                    </a>
                    <a routerLink="/testimonials" routerLinkActive="text-yellow-400"
                        class="text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal py-2"
                        (click)="closeMobileMenu(); scrollToSection('testimonials', $event)">
                        Testimonials
                    </a>
                    <button
                        class="text-left text-white hover:text-yellow-400 transition-colors duration-200 text-base font-normal py-2"
                        (click)="closeMobileMenu(); openContactModal()">
                        Contact Us
                    </button>
                </div>
            </div>
        </div>
    </div>
</nav>